import { SUPPORTED_LOCALES } from '../locales';

export function normalizeCatalogHubPath(pathname: string): string {
  const segments = pathname.split('/').filter((segment) => segment.length > 0);
  const hasLocale = SUPPORTED_LOCALES.includes(segments[0] as (typeof SUPPORTED_LOCALES)[number]);
  const locale = hasLocale ? segments[0] : undefined;
  const rest = hasLocale ? segments.slice(1) : segments;
  if (rest.length !== 1 || rest[0] !== 'explore') {
    return pathname;
  }
  return locale ? `/${locale}` : '/';
}
